module.exports = __webpack_public_path__ + "static/media/81mmD104.f9862270.png";